import React, { useState, useEffect } from "react";
import "../style/DescriptionGame.css";

const DescriptionGame = ({ match }) => {
  const [cardsData, setCardsData] = useState({});
  useEffect(() => {
    fetch(`https://brainsterboxapi.herokuapp.com/games/${match.params.id}`)
      .then((res) => res.json())
      .then((data) => {
        setCardsData(data);
        window.scrollTo(0, 0);
      });
  }, [match.params.id]);
  return (
    <div>
      <div
        className="descriptionGameImage"
        style={{ backgroundImage: `url(${cardsData.image})` }}
      ></div>
      <div className="DescriptionGame">
        <div className="descriptionGameContent">
          <h1>{cardsData.title}</h1>
          <div className="gameInfo">
            <div className="gameIn">
              <div className="gameIcon">
                <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                <p>Time Frame</p>
              </div>
              <p>{cardsData.timeFrame}</p>
            </div>
            <div className="gameIn">
              <div className="gameIcon">
                <i className="fa fa-users fa-lg" aria-hidden="true"></i>
                <p>Group Size</p>
              </div>
              <p>{cardsData.groupSize}</p>
            </div>
            <div className="gameIn">
              <div className="gameIcon">
                <i className="fa fa-university fa-lg" aria-hidden="true"></i>
                <p>Facilitation Level</p>
              </div>
              <p>{cardsData.level}</p>
            </div>
            <div className="gameIn">
              <div className="gameIcon">
                <i className="fa fa-paint-brush fa-lg" aria-hidden="true"></i>
                <p>Materials</p>
              </div>
              <p>{cardsData.materials}</p>
            </div>
          </div>
          <div className="steps">
            <p>{cardsData.description}</p>
            {cardsData.steps &&
              cardsData.steps.map((el) => {
                return (
                  <div key={el.step}>
                    <hr />
                    <h3>{el.step}</h3>
                    <p>{el.stepDescription}</p>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default DescriptionGame;
